import { WParagraph } from '@alice-health/wonderland-react'
import { CassiBadge } from '../CassiBadge'

const CassiCard = () => {
  return (
    <div className='flex flex-col gap-4'>
      <CassiBadge />

      <WParagraph variant='plain'>
        Para o atendimento, informe que seu plano é &quot;Cassi
        Reciprocidade&quot; - uma parceria da Alice que oferece cobertura em
        todo o Brasil.
      </WParagraph>
    </div>
  )
}

export { CassiCard }
